import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import "../index.css"
import swal from 'sweetalert';
import { Word, LightBg } from "./style";
import { 
    Button, 
    SimpleGrid, 
    Icon,
    Box, 
    HStack, 
    Text, VStack, 
    Center } from "@chakra-ui/react";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs"
import classes from "./styles.module.css"; 

import Footer from "../../components/Footer";
import Navigation from "../../components/Navbar";

import APIConfig from "../../api/APIConfig";
import AuthService from "../../services/auth.service";

import ReactLoading from "react-loading";

const LamarLowonganPage = (props) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [proposal, setProposal] = useState([]);
    const [mitra, setMitra] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);
    const [idPeserta, setIdPeserta] = useState(0);
    const [fileInfo2, setFileInfo2] = useState([]);
    const [urlDokumen, setUrlDokumen] = useState('');
    const [lowongan, setLowongan] = useState([]);
    const [validation, setValidation] = useState({});
    const [spinner, setSpinner] = useState(false); 

    const getLowongan = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/lowongan/${id}`);
        const result = await response.data;
        setLowongan(result);
        setProposal(result.proposal);
        setMitra(result.mitra);
        setSpinner(false);
    };

    const getCV = async(id) => {
        const response = await APIConfig.get(`/v1/cv/file/${id}`);
        const result = await response.data;
        setFileInfo2(result);
    };

    const getUrlDokumen = async(id) => {
        const response = await APIConfig.get(`/v1/urlDokumen/${id}`);
        const result = await response.data;
        setUrlDokumen(result.urlDokumen);
    };

    useEffect(() => {
        getLowongan();
    }, []);

    useEffect(() => {
        const user = AuthService.getCurrentUser();

        if(user) {
            setCurrentUser(user);
        }
        getCV(user.peserta[0].idPeserta);
        getUrlDokumen(user.peserta[0].idPeserta);
        setIdPeserta(user.peserta[0].idPeserta);
    }, []);

    function checkdata() {
        var test = false;
        if(currentUser.peserta[0].namaPeserta !== null
            && currentUser.peserta[0].jenisKelaminPeserta !== null
            && currentUser.peserta[0].nomorPonselPeserta !== null
            && currentUser.emailUser !== null
            && fileInfo2.length !== 0)
        test = true;

        else test = false;

        return test;
    }


    const lamarLowongan = async (e) => {
        e.preventDefault();
        swal({
            title: "Apakah anda telah yakin dengan data yang ingin dikumpulkan?",
            text: "Pastikan datamu sudah benar ya!",
            icon: "warning",
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Tidak",
                value: "no"
                }
            }
          })
          .then((value) => {
            if (value === "yes") {
                {checkdata() ? 
                    APIConfig.post(`v1/lowongan-peserta`, {
                        lowongan: lowongan,
                        peserta: currentUser.peserta[0]
                    })
                    .then(() => {
                        swal({
                            title: "Anda berhasil melamar lowongan ini",
                            icon: "success",
                            button: "OK",
                        }); 
                        console.log("berhasil") 
                        navigate(`/peserta/kegiatanku/statuspendaftaran/${currentUser.peserta[0].idPeserta}`);
            
                    })
                    .catch((error) => {
                        console.log(error);
                        setValidation(error.response.data);
                        console.log(error.response.data);

                        let resMessage;
                        resMessage = error.response.data;
            
                        if(resMessage.includes("Kuota peserta sudah penuh")) {
                            swal({
                                title: "Kuota peserta untuk lowongan ini sudah penuh",
                                text: "Lamaran gagal disimpan",
                                icon: "error",
                                button: "OK",
                            });   
                        }
                        else if(resMessage.includes("Anda telah aktif pada kegiatan lain")) {
                            swal({
                                title: "Maaf! Anda tidak bisa melamar karena saat ini anda telah aktif pada kegiatan lain",
                                text: "Lamaran gagal disimpan",
                                icon: "error",
                                button: "OK",
                            });   
                        }
                        else if(resMessage.includes("Anda telah aktif pada kegiatan lain")) {
                            swal({
                                title: "Maaf! Anda tidak bisa melamar karena saat ini anda telah aktif pada kegiatan lain",
                                text: "Lamaran gagal disimpan",
                                icon: "error",
                                button: "OK",
                            });   
                        }
                        else if(resMessage.includes("Anda sudah pernah melamar ke lowongan ini")) {
                            swal({
                                title: "Anda sudah pernah melamar ke lowongan ini",
                                text: "Lamaran gagal disimpan",
                                icon: "error",
                                button: "OK",
                            });   
                        }
                    })  
                :
                    swal({
                        title: "Datamu masih belum lengkap",
                        text: "Lamaran gagal disimpan",
                        icon: "error",
                        button: "OK",
                    }); 
                }
            } 
        });
    };

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <>
        <Navigation />
        <LightBg>
            <HStack color={'gray.500'} pb={3}>
                <Link to="/lowongan"> Daftar Lowongan </Link>
                <p> / </p>
                <Link to={`/lowongan/detail/${idPeserta}/${id}`}> {proposal.namaPosisi} </Link>
                <p> / </p>
                <Link to={`/lowongan/lamar/${id}`}> Lamar </Link>
            </HStack>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'3xl'}>
                Konfirmasi Lamaran Magang
            </Text>
            <p style={{fontSize: '24px', fontWeight: '600'}}>{proposal.namaPosisi}</p>
            <p style={{fontWeight: '600'}}>{mitra.namaResmi} | {proposal.lokasi}, Indonesia</p>
        </LightBg>

        <Center py={6}>
            <Box
                m='10px 0 100px 0'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={12}
                overflow={'hidden'}>
                <VStack 
                    spacing={8}
                    align='stretch'
                    >
                        <Text
                            pt={5}
                            color={'gray.900'}
                            fontWeight={650}
                            fontSize={'3xl'}
                            fontFamily={'Inter'}>
                            Data Pribadi Peserta
                        </Text>
                        {currentUser.peserta && currentUser.peserta.map((data) =>
                            <SimpleGrid pt={4} columns={[2, 2]} spacing='40px' padding={'0px 0'} fontFamily={'Inter'}>
                                <Box height='100%'>
                                    <Word style={{color: '#828282'}}>Nama Lengkap</Word>
                                    <Word>{data.namaPeserta}</Word>
                                </Box>
                                <Box height='100%'>
                                    <Word style={{color: '#828282'}}>Jenis Kelamin</Word>
                                    {data.jenisKelaminPeserta === 0 ? (
                                        <Word>Perempuan</Word> 
                                    ) : (
                                        <Word>Laki-laki</Word>
                                    )}
                                </Box>
                                <Box height='100%'>
                                    <Word style={{color: '#828282'}}>Nomor Ponsel</Word>
                                    <Word>{data.nomorPonselPeserta}</Word>
                                </Box>
                                <Box height='100%'>
                                    <Word style={{color: '#828282'}}>Email</Word>
                                    <Word>{currentUser.emailUser}</Word>
                                </Box>
                            </SimpleGrid>
                        )}
                </VStack>  
                <br></br><br></br>
                {currentUser.peserta && currentUser.peserta.map((data) =>
                <Link to={`/peserta/profile/isi-datapribadi/${data.idPeserta}`}>
                    <Button p={3} w='20%' rounded={'xl'} fontFamily={'Inter'}
                    style={{background: '#FFFFFF', color: '#6554C0', border: '2px solid #6554C0'}}>
                        Edit Data Diri
                    </Button>
                </Link>)}
                <Text
                        pt={5}
                        paddingTop={14}
                        paddingBottom={7}
                        color={'gray.900'}
                        fontWeight={650}
                        fontSize={'3xl'}
                        fontFamily={'Inter'}>
                        Dokumen Peserta
                    </Text>
                    <div>
                        <h3 className={classes.h} >Curriculum Vitae</h3>
                        <div>
                            <HStack pt={5} pb={5}>
                                <Icon mr="5px" fontSize={'xl'} as={BsFillFileEarmarkPdfFill} />
                                <a href={fileInfo2.url} style={{marginRight: '30px'}}>
                                    <p className={classes.p}>{fileInfo2.name}</p>
                                </a>
                            </HStack>
                        </div>
                        <br></br><br></br>
                        <h3 className={classes.h} >URL Tambahan</h3>
                        <div>
                            <HStack pt={5} pb={5}>
                                <a href={urlDokumen} style={{marginRight: '30px'}}>
                                    <p className={classes.p}>{urlDokumen}</p>
                                </a>
                            </HStack>
                        </div>
                        <br></br>
                        <Link to={`/peserta/dokumen/edit/${idPeserta}`}>
                            <Button p={3} w='20%' rounded={'xl'} fontFamily={'Inter'}
                            style={{background: '#FFFFFF', color: '#6554C0', border: '2px solid #6554C0'}}>
                                Edit Dokumen
                            </Button>
                        </Link>
                    </div>  
                    <br></br>
                    <Form onSubmit={lamarLowongan}>
                        <Center pt={6}>
                            <Button type='submit' p={6} w='30%' rounded={'xl'} colorScheme='purple' variant='solid' fontFamily={'Inter'}>
                                Lamar Sekarang
                            </Button>
                        </Center>
                    </Form>
            </Box>
        </Center>
        <Footer />
        </>
    );
}

export default LamarLowonganPage;